export interface IIPRDataItem {
  stage?: number | string
  value?: string
  actualValue?: string
}

export enum EIPRToothMap {
  UR_1 = "1",
  UR_2 = "2",
  UR_3 = "3",
  UR_4 = "4",
  UR_5 = "5",
  UR_6 = "6",
  UR_7 = "7",
  UR_8 = "8",
  //UL
  UL_1 = "1",
  UL_2 = "2",
  UL_3 = "3",
  UL_4 = "4",
  UL_5 = "5",
  UL_6 = "6",
  UL_7 = "7",
  UL_8 = "8",
  //LR
  LR_1 = "1",
  LR_2 = "2",
  LR_3 = "3",
  LR_4 = "4",
  LR_5 = "5",
  LR_6 = "6",
  LR_7 = "7",
  LR_8 = "8",
  //LL
  LL_1 = "1",
  LL_2 = "2",
  LL_3 = "3",
  LL_4 = "4",
  LL_5 = "5",
  LL_6 = "6",
  LL_7 = "7",
  LL_8 = "8",
}

export interface IIPRToothData {
  id: EIPRToothMap
  isMissingTooth: boolean
  icon: React.ReactNode
  point: number[]
  data: IIPRDataItem[]
}
